<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader">
        </loading>
        <div class="card">
          <div class="card-header text-center">
            <h5 class="text-primary">Kartu Stock</h5>
          </div>
          <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <dl class="row dl-custom">
                        <dt class="col-md-4">Date</dt>
                        <dd class="col-md-8">
                            <date-picker v-model="startDate" type="date" range placeholder="Select date range" class="ml-2 mr-1"></date-picker>
                        </dd>

                        <dt class="col-md-4">Product</dt>
                        <dd class="col-md-8">
                            <v-select class="vsc-custom ml-2" :options="productSelect" :reduce="product => product.meta.code" label="product" v-model="product_no"/>
                        </dd>

                        <dt class="col-md-4">&nbsp;</dt>
                        <dd class="col-md-8"><button type="button" class="btn btn-sm btn-hard-primary" @click="refreshList"><i class="fa fa-search" aria-hidden="true"></i> Search</button></dd>
                    </dl>
                </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs nav-bordered">
                  <li class="nav-item">
                    <a href="#group-kartu-stock" data-toggle="tab" aria-expanded="false" class="nav-link active">Group</a>
                  </li>
                  <li>
                    <a href="#raw-kartu-stock" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="group-kartu-stock">
                    <div class="table-responsive">
                      <table class="table table-item table-sm table-striped">
                          <thead>
                              <th>Date</th>
                              <th>Product</th>
                              <!-- <th>Masuk</th>
                              <th>Keluar</th> -->
                              <th class="text-right">Saldo</th>
                              <th class="text-center">Uom</th>
                          </thead>
                          <tbody>
                              <tr v-for="(g, index) in groupData" :key="index">
                                  <td>{{ g.date | dateFormat('DD/MM/YYYY') }}</td>
                                  <td>[{{ g.qty_stock }} {{ g.uom_stock }}] <b>[{{ g.product_no }}]</b> {{ g.product }}</td>
                                  <td class="text-right">{{ g.qty_in }} </td>
                                  <td class="text-center">{{ g.qty_in_uom }}</td>
                                  <!-- <td>{{ g.qty_out }} {{ g.qty_out_uom }}</td>
                                  <td>{{ g.qty_saldo }} {{ g.qty_saldo_uom }}</td> -->
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{ totalGroupData | currency }}</td>
                                <td></td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="tab-pane" id="raw-kartu-stock">
                    <div class="table-responsive">
                      <table class="table table-item table-sm table-striped table-hover">
                        <thead>
                          <th>Type</th>
                          <th>Hand No.</th>
                          <th>Serial Number</th>
                          <th>Date In</th>
                          <th>Date Out</th>
                          <th>Product</th>
                          <th>Ukuran Potong</th>
                          <th>Qty</th>
                          <th>Uom</th>
                          <th>Used</th>
                        </thead>
                        <tbody>
                          <tr v-for="i in inventory" :key="i.id">
                            <td>
                              <span class="badge badge-danger" v-if="i.c_type === 'out'">{{ i.c_type }}</span>
                              <span class="badge badge-success" v-else>{{ i.c_type }}</span>
                            </td>
                            <td>{{ i.hand_no }}</td>
                            <td>
                              <span data-toggle="modal" data-target="#modalOnHandDetail" data-backdrop="static" data-keyboard="false" @click="getInventoryDetail(i.id)" class="text-ref-sales">
                                {{ i.serial_number }}
                              </span>
                            </td>
                            <td>{{ i.hand_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td>{{ i.date_out | dateFormat('DD/MM/YYYY') }}</td>
                            <td>{{ i.product_no }} {{ i.product_description }}</td>
                            <td>{{ i.qty_stock }} {{ i.uom_stock }}</td>
                            <td>{{ i.qty }}</td>
                            <td>{{ i.uom_id }}</td>
                            <td>{{ i.used }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-4"><pre>{{ inventory }}</pre></div>
              <div class="col-md-4"><pre>{{ groupData }}</pre></div>
            </div> -->
          </div>
          <div class="card-footer"></div>
        </div>
        <InventoryOnHandDetailModal />
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, inventoryUrl } from '../config'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import InventoryOnHandDetailModal from '@/components/inventory/InventoryOnHandDetailModal.vue'

export default {
  name: 'InventoryOnHandKartuStock',
  components: { DatePicker, Loading, InventoryOnHandDetailModal },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      startDate: [date1, date2],
      product_no: null,
      inventory: [{
        id: null,
        hand_date: null,
        type: null,
        product_no: null,
        product_description: null,
        qty: 0,
        uom_id: null
      }]
    }
  },
  computed: {
    ...mapState({
      productListSelect: state => state.products.productListSelect
    }),
    productSelect () {
      var loop = []
      var array = this.productListSelect
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: '[' + array[i].product_no + '] ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    groupData () {
      var result = []
      this.inventory.reduce(function (res, value) {
        var key = value.hand_date + value.qty_stock
        var qtyIn = value.type === 'in' ? parseFloat(value.qty) : 0
        var qtyOut = value.type === 'out' ? parseFloat(value.qty) : 0
        var saldo = qtyIn - qtyOut
        if (!res[key]) {
          res[key] = {
            key: key,
            date: value.hand_date,
            hand_no: value.hand_no,
            product_no: value.product_no,
            product: value.product_description,
            qty_in: qtyIn,
            qty_in_uom: value.uom_id,
            qty_out: qtyOut,
            qty_out_uom: value.uom_id,
            qty_saldo: saldo,
            qty_saldo_uom: value.uom_id,
            qty_stock: parseFloat(value.qty_stock),
            uom_stock: value.uom_stock
          }
          result.push(res[key])
        } else {
          res[key].qty_in = parseFloat(res[key].qty_in) + parseFloat(qtyIn)
          res[key].qty_out = parseFloat(res[key].qty_out) + parseFloat(qtyOut)
          saldo = res[key].qty_in - res[key].qty_out
          res[key].qty_saldo = saldo
        }
        // console.log('saldo: ' + saldo)
        return res
      }, {})
      return result
    },
    totalGroupData () {
      var array = this.groupData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty_in)
      }
      return sum
    }
  },
  methods: {
    async getInventoryDetail (id) {
      var payload = {
        id: id
      }
      console.log(payload)
      this.$store.dispatch('getInventoryOnHandDetail', payload)
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        begin: begin,
        end: end,
        product_no: this.product_no
      }
      await Axios.post(inventoryUrl + '/on-hand/kartu-stock', data, { headers: getHeader() })
        .then(response => {
          this.inventory = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
    }
  },
  mounted () {
    var payload = {
      status: null
    }
    this.$store.dispatch('getProductListSelect', payload)
  }
}
</script>
